import React from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import LocationSearchingRoundedIcon from '@mui/icons-material/LocationSearchingOutlined';
import { bool, shape } from 'prop-types';
import { useDispatch } from 'react-redux';
import { snackBarError } from '#action/fetch';

const buildGeolocationErrorMessage = code => {
  switch (code) {
    case 1: // PERMISSION_DENIED
      return 'Location access denied, please allow in browser settings';
    case 2: // POSITION_UNAVAILABLE
    case 3: // TIMEOUT
    default:
      return 'Cannot get geolocation';
  }
};

const Geolocation = props => {
  const { serviceMethods, disabled } = props;
  const dispatch = useDispatch();

  const handleClick = () => {
    serviceMethods.dispatchClearOptions();
    serviceMethods.dispatchFetchOptionsStarted();
    const successHandler = async data => {
      const { latitude, longitude } = data?.coords ?? {};
      serviceMethods.fetchOptions(`${latitude},${longitude}`);
    };
    const errorHandler = e => {
      dispatch(snackBarError({
        message: buildGeolocationErrorMessage(e.code),
        ...e
      }));
    };

    navigator.geolocation.getCurrentPosition(successHandler, errorHandler);
  };

  return (
    <InputAdornment
      position="start"
      onClick={handleClick}
    >
      <IconButton size="small" aria-label="Current location" title="Current location" disabled={disabled}><LocationSearchingRoundedIcon /></IconButton>
    </InputAdornment>);
};

Geolocation.propTypes = {
  serviceMethods: shape({}).isRequired,
  disabled: bool
};

export default Geolocation;
